//  const BaseUrl = "http://localhost:8080";
 const BaseUrl = "https://haryanaseedsb.hkcl.net";
//  const BaseUrl = "https://seedsb.hkcl.net";

export default BaseUrl;